import {
  ADD_UQC,
  UPDATE_UQC,
  GET_UQC,
  GET_ALL_UQC,
  DELETE_UQC,
} from '../types';

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_UQC:
      return { ...state, list: payload };

    case GET_UQC:
      return { ...state, single: payload };

    case ADD_UQC:
      return {
        ...state,
        list: [payload, ...state.list],
      };

    case UPDATE_UQC:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case DELETE_UQC:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };

    default:
      return state;
  }
};

export default reducer;
